/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaSchema } from './MediaSchema';
import {
    MediaSchemaFromJSON,
    MediaSchemaFromJSONTyped,
    MediaSchemaToJSON,
    MediaSchemaToJSONTyped,
} from './MediaSchema';

/**
 * 
 * @export
 * @interface ConfirmCaptureMediaResponse
 */
export interface ConfirmCaptureMediaResponse {
    /**
     * 
     */
    media: MediaSchema;
}

/**
 * Check if a given object implements the ConfirmCaptureMediaResponse interface.
 */
export function instanceOfConfirmCaptureMediaResponse(value: object): value is ConfirmCaptureMediaResponse {
    if (!('media' in value) || value['media'] === undefined) return false;
    return true;
}

export function ConfirmCaptureMediaResponseFromJSON(json: any): ConfirmCaptureMediaResponse {
    return ConfirmCaptureMediaResponseFromJSONTyped(json, false);
}

export function ConfirmCaptureMediaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmCaptureMediaResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'media': MediaSchemaFromJSON(json['media']),
    };
}

export function ConfirmCaptureMediaResponseToJSON(json: any): ConfirmCaptureMediaResponse {
    return ConfirmCaptureMediaResponseToJSONTyped(json, false);
}

export function ConfirmCaptureMediaResponseToJSONTyped(value?: ConfirmCaptureMediaResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'media': MediaSchemaToJSON(value['media']),
    };
}

